import { Box, Stack, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CustomAccordion from '../shared/Custom-Accordion/CustomAccordion';
import NavLinks from './NavLinks';
import NavTitle from './NavTitle';

/**
 * @name NavList
 * @description Displays list of navigation links
 * @param {*} param0 - Destructured object
 * @param {object} param0.nav - Footer navigation data
 * @returns {JSX.Element} ReactElement
 */
const NavList = ({ nav }) => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.down('md'));

  return md ? (
    <CustomAccordion
      title={<NavTitle title={nav?.title} />}
      description={<NavLinks links={nav?.PrimaryNavL3?.map(data => data?.Link)} />}
    />
  ) : (
    <Stack>
      <Box>
        <NavTitle title={nav?.title} />
        <NavLinks links={nav?.PrimaryNavL3?.map(data => data?.Link)} />
      </Box>
    </Stack>
  );
};

export default NavList;
